import NavBar from "../components/NavBar";
import useFancybox from "../useFancybox";
import "./cert.css";
import ym from "react-yandex-metrika";
import { useEffect } from "react";

export default function Certificates() {
  const [fancyboxRef] = useFancybox({});

  useEffect(() => {
    ym("reachGoal", "certificates_page_visit");
  }, []);

  return (
    <main ref={fancyboxRef}>
      <NavBar />
      <h1 className="certificates-title">Мои сертификаты</h1>
      <ul className="certificates-list">
        <li className="certificates-list__item">
          <a
            className="lightbox group"
            data-gallery="multiimages"
            data-fancybox="multiimages"
            data-caption="Код будущего 2024"
            href={`${process.env.PUBLIC_URL}/cert_fc.png`}
          >
            <img
              className="certificates-list__img"
              src={`${process.env.PUBLIC_URL}/cert_fc.png`}
              title="Код будущего 2024"
              alt="Код будущего 2024"
            />
          </a>
        </li>
        <li className="certificates-list__item">
          <a
            className="lightbox group"
            data-gallery="multiimages"
            data-fancybox="multiimages"
            data-caption="МинЦифры 2025"
            href={`${process.env.PUBLIC_URL}/IMG_8897.jpeg`}
          >
            <img
              className="certificates-list__img certificafe-list__img_s"
              src={`${process.env.PUBLIC_URL}/IMG_8897.jpeg`}
              title="МинЦифры 2025"
              alt="МинЦифры 2025"
            />
          </a>
        </li>
        <li className="certificates-list__item">
          <a
            className="lightbox group"
            data-gallery="multiimages"
            data-fancybox="multiimages"
            data-caption="МинЦифры 2025"
            href={`${process.env.PUBLIC_URL}/IMG_8896.jpeg`}
          >
            <img
              className="certificates-list__img certificafe-list__img_s"
              src={`${process.env.PUBLIC_URL}/IMG_8896.jpeg`}
              title="МинЦифры 2025"
              alt="МинЦифры 2025"
            />
          </a>
        </li>
        <li className="certificates-list__item">
          <a
            className="lightbox group"
            data-gallery="multiimages"
            data-fancybox="multiimages"
            data-caption="МинЦифры 2025"
            href={`${process.env.PUBLIC_URL}/IMG_8898.jpeg`}
          >
            <img
              className="certificates-list__img certificafe-list__img_s"
              src={`${process.env.PUBLIC_URL}/IMG_8898.jpeg`}
              title="МинЦифры 2025"
              alt="МинЦифры 2025"
            />
          </a>
        </li>
      </ul>
    </main>
  );
}
